import { differenceInMilliseconds } from "date-fns";

export const adapterToFns = (begin: Date, finish: Date, value: string) => {
    const millisecondsInMonth = 2629746000;
    switch (value) {
        case "asMonths": {
           const diff = differenceInMilliseconds(finish, begin);
           // TODO Есть функция differenceInMonths, но для нее нет поддержки options { roundingMethod: "ceil" }. Заменить, как только появится
           return Math.ceil(diff/millisecondsInMonth);
        }
        default:
            return 0;
    }
};
